var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 24C42 28.61 40.266 32.817 37.416 36.001L29 27.586V26.844C29 24.127 27.898 21.52 25.938 19.599C25.8898 19.5523 25.8515 19.4963 25.8254 19.4345C25.7993 19.3726 25.7859 19.3061 25.786 19.239V10.7C25.786 10.313 25.466 10 25.071 10H23.286C23.1931 9.99894 23.1008 10.0162 23.0146 10.0508C22.9284 10.0855 22.8498 10.1367 22.7834 10.2018C22.717 10.2668 22.664 10.3442 22.6276 10.4297C22.5911 10.5152 22.5719 10.6071 22.571 10.7V19.227C22.5706 19.2974 22.5554 19.3669 22.5262 19.4311C22.4971 19.4952 22.4548 19.5524 22.402 19.599C21.3356 20.5336 20.4806 21.6848 19.894 22.9758C19.3074 24.2668 19.0026 25.668 19 27.086V36.454C19 37.308 19.706 38 20.577 38H27.317C28.247 38 29 37.261 29 36.35V30.414L36.001 37.416C32.7042 40.3738 28.4292 42.0067 24 42C14.059 42 6 33.941 6 24C6 19.262 7.83 14.952 10.823 11.737L18.293 19.207C18.4816 19.3892 18.7342 19.49 18.9964 19.4877C19.2586 19.4854 19.5094 19.3802 19.6948 19.1948C19.8802 19.0094 19.9854 18.7586 19.9877 18.4964C19.99 18.2342 19.8892 17.9816 19.707 17.793L12.265 10.351C15.5271 7.5382 19.6927 5.99371 24 6C33.941 6 42 14.059 42 24ZM44 24C44 35.046 35.046 44 24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24ZM21 26H27V31H21V26Z",
    fill: "#F90909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlcohol);
export default __webpack_public_path__ + "static/media/no-alcohol.3f2f202df9321ca2b04698750a93b79f.svg";
export { ForwardRef as ReactComponent };